import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Lock, Smartphone, EyeOff, ShieldCheck } from 'lucide-react';

const LandscapeLayout = ({ children }) => {
  return (
    <div className="min-h-screen w-full relative overflow-hidden bg-[#FFF0F3] flex flex-col font-sans">
      

      {/* Layered Background Elements */}
      <div className="absolute inset-0 z-0">
        {/* Sky & Sun */}
        <div className="absolute top-[10%] left-[50%] -translate-x-1/2 w-80 h-80 bg-white rounded-full blur-[100px] opacity-80" />
        
        {/* Animated Birds (Pink silhouettes) */}
        <motion.div 
          animate={{ x: [0, 100, 0], y: [0, -20, 0] }}
          transition={{ duration: 20, repeat: Infinity }}
          className="absolute top-40 left-[15%] text-rose-300 opacity-40"
        >
          <svg width="40" height="20" viewBox="0 0 40 20"><path d="M0,10 Q10,0 20,10 Q30,0 40,10" fill="none" stroke="currentColor" strokeWidth="2"/></svg>
        </motion.div>

        {/* Layered Hills (Comfort Silhouettes) */}
        <svg className="absolute bottom-0 w-full h-[60%] pointer-events-none" preserveAspectRatio="none" viewBox="0 0 1440 600">
          {/* Back Hill */}
          <path fill="#FFD1DC" fillOpacity="0.4" d="M0,400 Q360,200 720,400 T1440,400 L1440,600 L0,600 Z" />
          {/* Middle Hill */}
          <path fill="#FFB7C5" fillOpacity="0.5" d="M0,450 Q400,250 800,450 T1440,450 L1440,600 L0,600 Z" />
          {/* Front Hill (Rose tones) */}
          <path fill="#F43F5E" fillOpacity="0.15" d="M0,500 Q500,350 1000,500 T1440,500 L1440,600 L0,600 Z" />
        </svg>

        {/* Floral/Plant Silhouettes (Replacing Pine Trees) */}
        {/* <div className="absolute bottom-0 left-[-50px] md:left-10 opacity-20">
            <svg width="300" height="400" viewBox="0 0 100 100" fill="#9F1239">
                <path d="M50,100 Q40,50 50,0 Q60,50 50,100" />
                <circle cx="50" cy="20" r="15" />
                <circle cx="30" cy="40" r="12" />
                <circle cx="70" cy="40" r="12" />
            </svg>
        </div> */}
      </div>

      {/* Center Form Container */}
      <main className="flex-1 flex items-center justify-center relative z-10 px-6 pb-20">
        {children}
      </main>
    </div>
  );
};

export default LandscapeLayout